import MoreVertIcon from "@material-ui/icons/MoreVert";
import { Pill, PopOverMenu, Text } from "components/commons";
import { DateTime } from "enums";
import VIPRedemptionMethod from "enums/vip-redemption-method";
import VIPRedemptionStatus from "enums/vip-redemption-status";
import locale from "localization";
import moment from "moment";
import { formatAmount, formatNumber } from "utils";
import styles from "./redeem-points.module.scss";

const redemptionMethodLabel = {
  [VIPRedemptionMethod.LOCQPay]: locale.locqpayBalance,
  [VIPRedemptionMethod.Cash]: locale.cash,
};

const statusLabel = {
  [VIPRedemptionStatus.Pending]: locale.pending,
  [VIPRedemptionStatus.Success]: locale.success,
  [VIPRedemptionStatus.Failed]: locale.failed,
};

export const mapDataToList = ({ redemption, onUpdateStatus }) => {
  const {
    vipRedemptionId,
    cashinId,
    businessName,
    businessId,
    points,
    amount,
    redemptionMethod,
    status,
    createdAt,
    updatedAt,
  } = redemption;

  return {
    vipRedemptionIdCashInId: (
      <div>
        <Text>{vipRedemptionId}</Text>
        {cashinId && <Text className={styles.subText}>{cashinId}</Text>}
      </div>
    ),
    businessNameId: (
      <div>
        <Text>{businessName || "--"}</Text>
        <Text className={styles.subText}>{businessId || "--"}</Text>
      </div>
    ),
    pointsRedeemedAmount: (
      <div>
        <Text>{formatNumber(points, 0)}</Text>
        <Text className={styles.subText}>{formatAmount(amount)}</Text>
      </div>
    ),
    dateCreatedFulfilledDate: (
      <div>
        <Text>{moment(createdAt).format(DateTime.E)}</Text>
        {updatedAt && (
          <Text className={styles.subText}>{moment(updatedAt).format(DateTime.E)}</Text>
        )}
      </div>
    ),
    redemptionMethod: redemptionMethodLabel[redemptionMethod] || "--",
    status: (
      <Pill
        sky={status === VIPRedemptionStatus.Pending}
        grass={status === VIPRedemptionStatus.Success}
        deepRed={status === VIPRedemptionStatus.Failed}
      >
        {statusLabel[status]}
      </Pill>
    ),
    actions: (
      <PopOverMenu
        options={[
          {
            content: locale.updateToSuccess,
            disabled: status !== VIPRedemptionStatus.Pending,
            onClick: () => onUpdateStatus(vipRedemptionId, VIPRedemptionStatus.Success),
          },
          {
            content: locale.updateToFailed,
            disabled: status !== VIPRedemptionStatus.Pending,
            onClick: () => onUpdateStatus(vipRedemptionId, VIPRedemptionStatus.Failed),
          },
        ]}
      >
        <MoreVertIcon className={styles.actionIcon} />
      </PopOverMenu>
    ),
  };
};

export const mapFilterToRequest = (filterState) => {
  const { statuses, ...fs } = filterState;

  return {
    ...fs,
    statuses: (statuses.length ? statuses : Object.values(VIPRedemptionStatus)).join(","),
  };
};
